import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Familygettogether() {



    const cardData =
    {
        keyword: 'Family Get-Together Morachi Chincholi Near Pune',
        heading: 'Anand Krushi Paryatan Kendra: Family Get-Together Morachi Chincholi Near Pune',
        headingDescription: 'Planning a peaceful and fun-filled family get-together Morachi Chincholi near Pune? Anand Krushi Paryatan Kendra, just 55 km from the city, is the perfect destination to reconnect with loved ones amidst nature, fresh air, and rural charm. This 40-acre agri-tourism retreat offers a wholesome and relaxing experience for guests of all ages. The venue is packed with engaging activities like bullock cart and tractor rides, horse riding, boating, swimming, and a lively rain dance zone. Families can enjoy puppet shows, magic performances, and traditional village games, making it a memorable day for both kids and elders.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Spacious Outdoor Gathering Lawns",
    "description": "Celebrate with your entire family in wide, open green spaces perfect for group games, meals, and bonding. The lush rural setting and peaceful atmosphere make it ideal for a relaxing and joyful family reunion."
  },
  {
    "title": "Traditional Maharashtrian Meals",
    "description": "Enjoy unlimited thali meals with all-time favorites like zunka-bhakar, bharli vangi, varan-bhat, and puranpoli. Meals are served under rustic bamboo sheds or under the shade of mango trees for an authentic countryside vibe."
  },
  {
    "title": "Bullock Cart & Tractor Safari",
    "description": "Recreate childhood joy with scenic tractor or bullock cart rides across farmlands and orchards. It's a unique way for grandparents, parents, and kids to explore the village together."
  },
  {
    "title": "Kids’ Play Zone & Farm Fun",
    "description": "Children will love the swings, rope bridges, tire climbing areas, and animal feeding corners. The play zone is safe, supervised, and designed for all-day engagement while adults relax nearby."
  },
  {
    "title": "Traditional Rural Games",
    "description": "Relive memories and introduce kids to Indian village games like gilli-danda, lagori, sack race, kho-kho, and kabaddi. These games bring laughter and energy to any family outing."
  },
  {
    "title": "Farm Walks & Nature Trails",
    "description": "Stroll through shaded trails, flower beds, vegetable patches, and sugarcane fields. Spot birds like parrots and kingfishers or even peacocks dancing in the open, making for beautiful shared experiences."
  },
  {
    "title": "Rain Dance & Water Zone",
    "description": "Cool off together in the splash pool or join a fun-filled rain dance with DJ music. This lively activity is a hit with all age groups and adds a modern twist to the rustic setting."
  },
  {
    "title": "Group Activities & Cultural Shows",
    "description": "Bond through group activities like pottery, diya painting, or folk dance sessions. Live lavani or puppet shows can be arranged for entertainment, especially during weekends or special bookings."
  },
  {
    "title": "Evening Bonfire & Tea Snacks",
    "description": "Gather around a crackling bonfire in the evening for tea, bhadang, and dholki music. Share stories, laugh together, or simply enjoy the starlit countryside sky as a family."
  },
  {
    "title": "Day or Overnight Stay Packages",
    "description": "Choose from one-day family picnic options or overnight stays in cozy cottages or dorm-style rooms. Packages include all meals, activities, and guided tours—customized to your group’s size and preferences."
  }
],




  "services": [
    {
      "name": "Family Picnic Venues near Pune",
      "description": "Beautiful open spaces close to Pune that offer a perfect blend of nature, comfort, and entertainment, ideal for family picnics with ample seating and clean amenities."
    },
    {
      "name": "Group Lunch and Gathering Locations",
      "description": "Resorts and farms equipped with spacious dining halls and outdoor seating arrangements designed for large family groups to enjoy meals together comfortably."
    },
    {
      "name": "Resorts for Family Reunions",
      "description": "Resorts near Pune offering comfortable accommodation, private lawns, and recreational facilities, perfect for multi-generational family reunions and celebrations."
    },
    {
      "name": "Kids-Friendly Farm Outing",
      "description": "Farms with dedicated kids’ play zones, petting animals, safe adventure activities, and educational workshops to keep children engaged and happy."
    },
    {
      "name": "Senior-Friendly Nature Spots",
      "description": "Peaceful, accessible nature locations with gentle walking trails, shaded rest areas, and easy terrain for senior family members to relax and enjoy."
    },
    {
      "name": "Outdoor Games for Families",
      "description": "Venues offering fun outdoor games such as cricket, badminton, sack race, tug-of-war, and more to encourage active family bonding and laughter."
    },
    {
      "name": "Family BBQ Picnic Ideas",
      "description": "Farms and resorts equipped with BBQ pits and picnic tables where families can enjoy grilled meals together in an open-air environment."
    },
    {
      "name": "Day Stay with Meals for Families",
      "description": "Locations offering comfortable day stay packages inclusive of wholesome lunch and snacks to make family outings hassle-free and enjoyable."
    },
    {
      "name": "Bullock Cart Ride for All Ages",
      "description": "Traditional bullock cart rides available for all family members, adding a rustic charm and memorable experience to the picnic day."
    },
    {
      "name": "Comfortable Seating and Lunch Area",
      "description": "Well-maintained shaded seating areas with clean dining facilities to provide comfort and convenience during family meals."
    },
    {
      "name": "Cultural Family Experience",
      "description": "Experiences including folk dance, traditional music, and local crafts that immerse families in the rich rural culture of Maharashtra."
    },
    {
      "name": "Safe and Hygienic Farm for Families",
      "description": "Farms with strict hygiene practices, child-safe zones, and well-maintained restrooms ensuring a clean and secure environment."
    },
    {
      "name": "Weekend Bonding Trip Ideas",
      "description": "Suggestions for quick weekend getaways from Pune where families can reconnect, enjoy nature, and participate in fun activities."
    },
    {
      "name": "Affordable Get-Together Packages",
      "description": "Budget-friendly options that include venue, meals, and activities making it easy for families to plan group outings without financial stress."
    },
    {
      "name": "Fun Activities for All Age Groups",
      "description": "A mix of adventure, educational, and leisure activities tailored to entertain children, adults, and seniors alike."
    }
  ],
  "tableData": [
    ["Family Picnic Venues near Pune", "Group Lunch and Gathering Locations"],
    ["Resorts for Family Reunions", "Kids-Friendly Farm Outing"],
    ["Senior-Friendly Nature Spots", "Outdoor Games for Families"],
    ["Family BBQ Picnic Ideas", "Day Stay with Meals for Families"],
    ["Bullock Cart Ride for All Ages", "Comfortable Seating and Lunch Area"],
    ["Cultural Family Experience", "Safe and Hygienic Farm for Families"],
    ["Weekend Bonding Trip Ideas", "Affordable Get-Together Packages"],
    ["Fun Activities for All Age Groups", ""]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Ideal for Family Reunions",
    "WhyChoosedescription": "Morachi Chincholi offers a serene environment perfect for family get-togethers. With various resorts providing packages tailored for families, it's an excellent destination to reconnect with loved ones."
  },
  {
    "WhyChooseheading": "Engaging Activities for All Ages",
    "WhyChoosedescription": "From bullock cart rides to traditional games like Lagori and Gilli Danda, families can engage in activities that cater to all age groups, ensuring everyone has a memorable time."
  },
  {
    "WhyChooseheading": "Authentic Rural Experience",
    "WhyChoosedescription": "Experience the charm of rural Maharashtra with activities like Hurda parties, mango festivals, and peacock watching, offering a unique cultural immersion."
  },
  {
    "WhyChooseheading": "Comfortable Accommodation Options",
    "WhyChoosedescription": "Choose from day packages or overnight stays with comfortable accommodations, including cottages and dormitories, ensuring a pleasant stay for all family members."
  },
  {
    "WhyChooseheading": "Proximity to Pune",
    "WhyChoosedescription": "Located approximately 50 km from Pune, Morachi Chincholi is easily accessible, making it a convenient choice for a quick family getaway."
  }
]



























    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Is Morachi Chincholi a good place for a family get-together near Pune?',
    answer: 'Yes! Morachi Chincholi offers a peaceful and scenic environment perfect for family get-togethers with plenty of activities for all age groups.',
  },
  {
    id: 'FAQ2',
    question: 'What activities are available for families at Morachi Chincholi?',
    answer: 'Families can enjoy peacock watching, farm visits, bullock cart rides, outdoor games, nature walks, and traditional Maharashtrian meals.',
  },
  {
    id: 'FAQ3',
    question: 'Are there accommodation options suitable for families?',
    answer: 'Yes, there are several resorts and homestays that provide comfortable accommodation with family-friendly amenities.',
  },
  {
    id: 'FAQ4',
    question: 'Can I organize a special meal or feast for my family gathering?',
    answer: 'Absolutely, most agro-tourism centers offer customized meal plans including traditional farm-to-table dishes ideal for family celebrations.',
  },
  {
    id: 'FAQ5',
    question: 'Is Morachi Chincholi easily accessible from Pune for a day trip?',
    answer: 'Yes, it is about 60-65 km from Pune and reachable by car or taxi within 1.5 to 2 hours, making it convenient for day trips or overnight stays.',
  },
  {
    id: 'FAQ6',
    question: 'Are there facilities for kids during a family get-together?',
    answer: 'Yes, many places have play areas, farm activities, and safe open spaces where children can enjoy themselves.',
  },
  {
    id: 'FAQ7',
    question: 'Can I book event spaces for family functions at Morachi Chincholi?',
    answer: 'Yes, many resorts offer event halls and open lawns that can be booked for family functions and gatherings.',
  },
  {
    id: 'FAQ8',
    question: 'Is there a best time of year to plan a family get-together here?',
    answer: 'The ideal time is between October and March when the weather is pleasant and perfect for outdoor activities.',
  },
  {
    id: 'FAQ9',
    question: 'Can vegetarian and special diet meals be arranged?',
    answer: 'Yes, most venues accommodate dietary preferences including vegetarian, vegan, and other special diets upon prior request.',
  },
  {
    id: 'FAQ10',
    question: 'How do I book a family get-together package at Morachi Chincholi?',
    answer: 'You can contact resorts or agro-tourism centers directly via phone or website to inquire about packages and availability.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Patil, Pune',
    feedback: "Our family get-together at Morachi Chincholi was fantastic! The kids loved the farm activities, and the peaceful setting was perfect for us all to relax.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Snehal Kulkarni, PCMC',
    feedback: "We had a memorable family reunion at Morachi Chincholi. Great food, warm hospitality, and lots of fun for every generation. Highly recommended!",
    rating: 5,
  },
];






























    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Family Get-Together Morachi Chincholi Near Pune",
  "image": "https://morachichincholi.in/assets/images/family-get-together.jpg",
  "description": "Family picnic venues near Pune offering group lunch, resorts for family reunions, kids-friendly farm outings, senior-friendly nature spots, outdoor games, BBQ picnic ideas, bullock cart rides, cultural experiences, and affordable weekend bonding packages.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "815"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/family-get-together"
  }
};



    return (
        <div>

<Helmet>
  <title>Family Get-Together Morachi Chincholi Near Pune | Picnic & Reunion Venues</title>
  <meta 
    name="description" 
    content="Plan your family get-together near Pune at Morachi Chincholi with group lunch locations, family reunion resorts, kids-friendly farm outings, outdoor games, bullock cart rides, cultural family experiences, and affordable packages." 
  />
  <meta 
    name="keywords" 
    content="Family picnic venues near Pune, Group lunch and gathering locations, Resorts for family reunions, Kids-friendly farm outing, Senior-friendly nature spots, Outdoor games for families, Family BBQ picnic ideas, Day stay with meals for families, Bullock cart ride for all ages, Comfortable seating and lunch area, Cultural family experience, Safe and hygienic farm for families, Weekend bonding trip ideas, Affordable get-together packages, Fun activities for all age groups" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/34.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Familygettogether;